import { useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "../lib/api";
import { KioskShell } from "../components/KioskShell";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { SignaturePad } from "../components/SignaturePad";
import { toast } from "sonner";
import { CheckCircle2 } from "lucide-react";

export default function TestDriveWaiverPage() {
  const { vehicleId } = useParams();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [license, setLicense] = useState("");
  const [done, setDone] = useState(false);
  const padRef = useRef(null);

  const submit = async () => {
    const sig = padRef.current?.getDataURL();
    if (!sig || !name) { toast.error("Please complete all fields and sign"); return; }
    try {
      // Create customer record then waiver
      const { data: cust } = await api.post("/customers", { full_name: name, drivers_license: license });
      await api.post("/waivers", { customer_id: cust.id, vehicle_id: vehicleId, signature_data: sig });
      setDone(true);
    } catch (e) {
      toast.error("Could not submit waiver");
    }
  };

  return (
    <KioskShell onBack={() => navigate(`/kiosk/vehicle/${vehicleId}`)}>
      <section className="max-w-3xl mx-auto px-6 py-12">
        <div className="label-eyebrow mb-3" style={{ color: "var(--wakzy-gold)" }}>Test Drive Waiver</div>
        <h1 className="font-heading text-4xl mb-6">Schedule &amp; sign your test drive waiver</h1>
        {done ? (
          <div className="surface p-12 rounded-md text-center">
            <CheckCircle2 className="w-14 h-14 mx-auto mb-4" style={{ color: "var(--wakzy-gold)" }} />
            <div className="font-heading text-2xl mb-2">Thanks, {name.split(" ")[0]}!</div>
            <p className="text-slate-400 mb-6">A sales associate will be right with you.</p>
            <Button onClick={() => navigate("/kiosk")} className="btn-gold rounded-sm">Back to inventory</Button>
          </div>
        ) : (
          <div className="surface p-8 rounded-md">
            <p className="text-sm text-slate-300 mb-6 leading-relaxed">
              By signing below, you acknowledge that you possess a valid driver's
              license and have provided accurate information. You assume responsibility
              for the vehicle during the test drive and agree to operate it safely and
              in compliance with all traffic laws.
            </p>
            <div className="grid md:grid-cols-2 gap-4 mb-6">
              <div>
                <Label className="text-sm text-slate-300">Full legal name</Label>
                <Input value={name} onChange={(e) => setName(e.target.value)} className="bg-[#030712] border-white/10 mt-1 h-11" data-testid="waiver-name-input" />
              </div>
              <div>
                <Label className="text-sm text-slate-300">Driver license #</Label>
                <Input value={license} onChange={(e) => setLicense(e.target.value)} className="bg-[#030712] border-white/10 mt-1 h-11" data-testid="waiver-license-input" />
              </div>
            </div>
            <div className="label-eyebrow mb-3">Sign below</div>
            <SignaturePad ref={padRef} />
            <Button onClick={submit} className="btn-cta rounded-sm h-12 px-8 mt-6" data-testid="waiver-submit-btn">
              Submit Waiver
            </Button>
          </div>
        )}
      </section>
    </KioskShell>
  );
}
